import { Typography } from "@mui/material";

const CustomDialogTitle = ({ ...props }) => {
  const sx = props.sx;
  const title = props.title;
  const subTitle = props.subTitle;
  return (
    <Typography
      variant="body2"
      color="textSecondary"
      sx={{
        ...sx,
        fontWeight: "bold",
        color: "#465384",
        textTransform: "uppercase",
        fontSize: "0.875rem",
      }}
    >
      {props.title ? props.title : ""}
      {props?.subTitle ? `: ${props.subTitle}` : ""}
    </Typography>
  );
};

export default CustomDialogTitle;
